import { render, staticRenderFns } from "./mgrStudentStop.vue?vue&type=template&id=54241674&scoped=true&"
import script from "./mgrStudentStop.vue?vue&type=script&lang=js&"
export * from "./mgrStudentStop.vue?vue&type=script&lang=js&"
import style0 from "./mgrStudentStop.vue?vue&type=style&index=0&id=54241674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54241674",
  null
  
)

export default component.exports